import axios from "axios";
export const apiCall_domain = "https://xyz.kacharlife.com/v1";
// export const apiCall_domain = "https://xyz.kacharcar.ir/v1";
export const apiCall_domainV2 = "https://xyz.kacharlife.com/v2";
// export const apiCall_domainV2 = "https://xyz.kacharcar.ir/v2";
export const token = () => {
  let keys = ["1f28a87cf0", "11f3931209", "963092a98e", "51eeea3a1e"];
  let timee = parseInt(Date.now() / 1000);
  let timeS = timee.toString();
  let mutiplex = btoa(timeS.substr(6, 10) * 5 + 121);
  let finalltoken = btoa(
    btoa(keys[Math.floor(Math.random() * 4)] + timeS + mutiplex)
  );
  return finalltoken;
};
